import React from 'react';

import { Skeleton } from 'lighthouse';

import { TrustBadges } from '../TrustBadges';

export const BuyBoxSkeleton = () => {
    return (
        <aside
            className='nice-scroll sticky top-20 max-h-[calc(100vh-6rem)] w-full self-start overflow-y-auto rounded-lg bg-white
                shadow-[0_1px_3px_rgba(15,60,100,0.05),0_10px_30px_rgba(15,60,100,0.07)]'>
            <div className='flex flex-col gap-4 p-4'>
                <div className='flex flex-col items-center gap-3 rounded-lg border border-solid border-gray-100 bg-gray-50 px-4 py-6'>
                    <Skeleton variant='rectangular' width={180} height={20} className='rounded' />
                    <Skeleton variant='rectangular' width='85%' height={14} className='rounded' />
                    <Skeleton variant='rectangular' width='70%' height={14} className='rounded' />
                </div>

                <Skeleton variant='rectangular' width='100%' height={44} className='rounded-lg' />

                <TrustBadges />
            </div>
        </aside>
    );
};
